<template>
  <div class="offer-card offer-card--horizontal">
    <img loading="lazy" v-if="image" v-bind:src="imageSrc" alt="" class="offer-card__image" />
    <div class="offer-card__content">
      <div class="offer-card__rating" :data-rating="stars"><span class="sr-only">estrelas: {{rating}}</span></div>
      <h3 class="offer-card__title">{{name}}</h3>
      <div class="offer-card__description" v-html="description"></div>
      <address v-if="address">
        <b-icon-geo-alt></b-icon-geo-alt>{{address}}
      </address>
    </div>
  </div>
</template>

<script>
import { BIconGeoAlt } from 'bootstrap-vue'

export default {
  name: 'Experience',
  props: {
    image: String,
    name: String,
    description: String,
    address: String,
    rating: Number
  },
  computed: {
    stars: function() {
      return '★'.repeat(this.rating)
    },
    imageSrc: function() {
      return require('./../assets/images/' + this.image)
    }
  },
  components: {
    BIconGeoAlt
  }
}
</script>